import type { PathRouteType } from "$/lib/types/routes.types";

export const ROUTES = {
  HOMEPAGE: "/",
  LOGIN: "/login",
  VERIFY_EMAIL: "/verify-email",
  // Profile
  PROFILE_GENERAL: "/profile/general",
  PROFILE_SOCIALSECURITY: "/profile/social-security",
  PROFILE_FISCAL: "/profile/profile-fiscal",
  ACCOUNTING_DATA: "/profile/accounting-data",
  // management (gestion)
  MANAGEMENT_MYBUSINESS: "/management/my-business",
  MANAGEMENT_SOCIALCONTRIBUTIONS: "/management/social-contributions",
  MANAGEMENT_MYTAX: "/management/my-tax",
  MANAGEMENT_MYSUMMARY: "/management/my-summary",
  // Mobile uniquement : onglet combiné "Mes cotisations" (cotisations sociales + impôts)
  MANAGEMENT_MYCONTRIBUTIONS: "/management/my-contributions",
  // Transactions
  TRANSACTIONS: "/transactions",
  // Optimization
  OPTIMIZATION: "/optimization",
  // Help
  HELP_HOME: "/help",
  HELP_VIDEO: "/help/video-explain",
  HELP_MYTRANSACTIONS: "/help/my-transactions",
  HELP_MYACTIVITY: "/help/my-activity",
  HELP_SOCIALSECURITY: "/help/social-security",
  HELP_TAXES: "/help/taxes",
  HELP_OPTIMIZATION: "/help/optimization",
  HELP_PROFILE: "/help/profile",
  HELP_MYOPTIMIZATION: "/help/my-optimization",
  HELP_SPECIAL_CHARGES: "/help/special-charges",
  HELP_TRANSACTION_ACTIONS: "/help/transaction-actions",
  HELP_BANKING: "/help/banking",
  //  User info
  USER_INFO: "/user-info",
  // Abonnement
  SUBSCRIPTION: "/Abonnement/paiement",
  // Simulateur mobile (public)
  SIMULATEUR: "/simulateur",
} satisfies Record<string, PathRouteType>;

// Ancres des pages d'aide
export const HELP_ANCHORS = {
  MANAGEMENT_DEPRECIATIONS: "amortissements",
  LAUNDRY_FEES: "frais-de-blanchisserie",
} as const;